var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#13C270"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07714 4.74266C8.4666 4.6383 8.84131 4.86836 8.95437 5.29027L9.36368 6.81784L10.5483 6.50042L10.139 4.97286C10.0216 4.53471 10.2516 4.16 10.6573 4.0513C11.063 3.94259 11.4215 4.177 11.5345 4.59892L11.9518 6.156C13.6296 5.91002 14.9896 6.7154 15.4036 8.26055C15.6254 9.08815 15.4878 9.8729 15.0503 10.5119C16.4085 10.5828 17.4202 11.3727 17.7767 12.7033C18.2724 14.5533 17.1998 16.1973 15.1389 16.7495L14.8136 16.8367L15.2231 18.3649C15.3362 18.7868 15.1429 19.169 14.7372 19.2778C14.3315 19.3865 13.945 19.177 13.8276 18.7388L13.4181 17.2106L12.2335 17.528L12.6429 19.0562C12.756 19.4782 12.5465 19.8648 12.1571 19.9691C11.7514 20.0778 11.3648 19.8683 11.2474 19.4302L10.8379 17.902L9.04138 18.3816C8.6255 18.4931 8.19803 18.2463 8.08659 17.8304C7.97516 17.4145 8.22196 16.987 8.63784 16.8756L10.1425 16.4724L8.08044 8.77659L6.57324 9.18045C6.15736 9.29188 5.72989 9.04508 5.61846 8.6292C5.50703 8.21332 5.75383 7.78585 6.1697 7.67442L7.96826 7.19236L7.5588 5.66422C7.4414 5.22607 7.67145 4.85136 8.07714 4.74266ZM13.6891 8.80692C13.4456 7.89818 12.706 7.53978 11.6674 7.81806L9.76882 8.3268L10.5428 11.2153L12.4414 10.7066C13.4638 10.4326 13.9369 9.73189 13.6891 8.80692ZM11.8298 16.0187L14.5885 15.2795C15.7569 14.9664 16.2895 14.1628 16.0112 13.1242C15.7329 12.0857 14.8655 11.6398 13.6972 11.9528L10.9385 12.692L11.8298 16.0187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinCash);
export default __webpack_public_path__ + "static/media/bitcoin-cash.864f9f09be1ec2910f95f55b98332998.svg";
export { ForwardRef as ReactComponent };